/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
*/

import React from 'react';
import { HeaderWrapper } from './StickyHeader.css';
import Header from './Header';
import { useRecoilState } from 'recoil';
import { userState } from '../../../recoil/atoms/userAtoms';

interface Props {}

const StickyHeader = (_props: Props) => {
  const [user] = useRecoilState(userState);
  return (
    <>
      <HeaderWrapper isLightsOn={user.isLightsOn}>
        <Header />
      </HeaderWrapper>
    </>
  );
};

export default StickyHeader;
